import axios from "axios";

//Utils
import { API_ERROR_CODE, OPERATION_STATUS } from "./axios.init";
import { APPLICATION_CONFIGURATIONS } from "../Utils/ApplicationConfigurations";

let interceptorResponse;
export const initializeInterceptors = (history, logoutAction) => {
  interceptorResponse = axios.interceptors.response.use(
    (res) => {
      return res;
    },
    (error) => {
      return new Promise((resolve, reject) => {
        if (
          error.response.status === API_ERROR_CODE.UNAUTHORIZED &&
          !window.location.href.endsWith("/")
        ) {
          logoutAction((apiResponse) => {
            if (apiResponse.status === OPERATION_STATUS.SUCCESS) {
              history.push(APPLICATION_CONFIGURATIONS.path.login);
            }
          });
        } else {
          reject(error);
        }
      });
    }
  );
};

export const removeInterceptors = () => {
  interceptorResponse &&
    axios.interceptors.response.eject(interceptorResponse);
};
